"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  NAME: 'name',
  CONTENT: 'content',
  HTTP_EQUIV: 'http-equiv',
  PROPERTY: 'property',
  REL: 'rel',
  HREF: 'href',
  SIZES: 'sizes',
  TYPE: 'type',
  TITLE: 'title',
  MEDIA: 'media'
};
exports["default"] = _default;